import React from 'react';
import ReactDOM from 'react-dom/client';
import Layout from './Layout';
import PortfolioPage from './Pages/Portfolio';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Layout>
      <PortfolioPage />
    </Layout>
  </React.StrictMode>
);
